export { ChevronDoubleDown as default } from './ChevronDoubleDown';
